import ImportProgressModalView from './importProgressModal.view';

export default ImportProgressModalView;
